class CustomerProductListController {
  constructor(CustomerApiService, $timeout, $scope) {
    'ngInject';

    this.CustomerApiService = CustomerApiService;
    this.$timeout = $timeout;
    this.$scope = $scope;
  }

  $onInit() {
    this.loadCustomerProducts();

    // Listen for broadcasted event on parent's scope.
    this.$scope.$on('reload.customer-products', () => {
      this.loadCustomerProducts();
    });
  }

  loadCustomerProducts() {
    this.CustomerApiService.getCustomerProducts().then(customerProducts => {
      this.customerProducts = customerProducts;
      this.$timeout(() => {
            $('#myProductsTable').footable();
            $('#myProductsTable').trigger('footable_redraw');
      }, 0);
    });
  }
}

export default CustomerProductListController;


// WEBPACK FOOTER //
// ./client/app/shared/system-components/customer-products-list.controller.js